// import React, { useState, useEffect } from 'react';
// import { Link, useNavigate } from 'react-router-dom';
// import { Modal, Button } from 'react-bootstrap';
// import { motion, AnimatePresence } from 'framer-motion';
// import { serverUrlAuth } from '../../../serverUrl';
// import FurnitureNavbar from '../../../components/layout/Nav';
// import './updates.scss';
// import withAuth from '../../auth/WithAuth';
// import { IoClose } from 'react-icons/io5';
// import { FaEnvelope, FaRocket, FaProjectDiagram, FaClock, FaCalendar, FaImage } from 'react-icons/fa';

// const ClientProjectUpdates = () => {
//   const navigate = useNavigate();
  
//   const [projects, setProjects] = useState([]);
//   const [selectedImage, setSelectedImage] = useState(null);
//   const [isMarkingRead, setIsMarkingRead] = useState(false);
//   const [loading, setLoading] = useState(true);

//   useEffect(() => {
//     fetchProjects();
//   }, []);

//   const fetchProjects = async () => {
//     setLoading(true);
//     try {
//       const res = await serverUrlAuth.get('/projects/client-project-updates/');
//       setProjects(res.data);
//     } catch (err) {
//       console.error('Error fetching projects:', err);
//     } finally {
//       setLoading(false);
//     }
//   };

//   const markMessagesAsRead = async (projectId) => {
//     if (!projectId) return;

//     setIsMarkingRead(true);
//     try {
//       await serverUrlAuth.post(`/updates/messages/${projectId}/mark-read/`);
//       await fetchProjects();
//     } catch (err) {
//       console.error('Error marking messages as read:', err);
//     } finally {
//       setIsMarkingRead(false);
//     }
//   };

//   const handleOpenMessages = async (project) => {
//     await markMessagesAsRead(project.id);
//     navigate('/messages');
//   };

//   const formatTime = (dateString) => {
//     if (!dateString) return 'No messages yet';
//     const date = new Date(dateString);
//     const now = new Date();
//     const diffMs = now - date;
//     const diffMins = Math.floor(diffMs / 60000);
//     const diffHours = Math.floor(diffMs / 3600000);
//     const diffDays = Math.floor(diffMs / 86400000);

//     if (diffMins < 1) return 'Just now';
//     if (diffMins < 60) return `${diffMins}m ago`;
//     if (diffHours < 24) return `${diffHours}h ago`;
//     if (diffDays === 1) return 'Yesterday';
//     if (diffDays < 7) return `${diffDays}d ago`;
//     return date.toLocaleDateString();
//   };

//   const getProgressColor = (progress) => {
//     if (progress < 30) return '#ff6b6b';
//     if (progress < 70) return '#673200';
//     return '#4caf50';
//   };

//   const getTotalUnreadCount = () => {
//     return projects.reduce((total, project) => total + (project.unread_updates_count || 0), 0);
//   };

//   if (loading) {
//     return (
//       <div className="modern-dashboard">
//         <div className="dashboard-loader">
//           <div className="wooden-spinner"></div>
//           <p>Crafting your experience...</p>
//         </div>
//       </div>
//     );
//   }

//   return (
//     <div className="modern-dashboard">
//       <FurnitureNavbar />

//       {/* Hero Section */}
//       <section className="hero-craftsmanship">
//         <div className="hero-pattern"></div>
//         <div className="hero-content-modern">
//           <div className="welcome-badge">
//             <span className="badge-icon">📢</span>
//             <span>Project Updates</span>
//           </div>
//           <h1 className="hero-title">
//             <span className="gradient-text">Stay Informed</span>
//             <span className="hero-accent">Track Your Progress</span>
//           </h1>
//           <p className="hero-subtitle">
//             Stay informed about your project progress with real-time updates from artisans.
//             Never miss an important milestone or message.
//           </p>
//           <div className="hero-stats-modern">
//             <div className="stat-item">
//               <FaProjectDiagram className="stat-icon" />
//               <div>
//                 <h3>{projects.length}</h3>
//                 <p>Total Projects</p>
//               </div>
//             </div>
//             <div className="stat-item">
//               <FaEnvelope className="stat-icon" />
//               <div>
//                 <h3>{getTotalUnreadCount()}</h3>
//                 <p>Unread Messages</p>
//               </div>
//             </div>
//           </div>
//         </div>
//       </section>

//       {/* Main Content */}
//       <div className="projects-showcase">
//         <div className="section-header-modern">
//           <h2>
//             <span className="header-icon">📋</span>
//             Your Projects
//             <span className="header-line"></span>
//           </h2>
//         </div>

//         {projects.length === 0 ? (
//           <div className="empty-state-modern">
//             <div className="empty-icon">📭</div>
//             <h3>No projects with updates yet</h3>
//             <p>When artisans send you updates about your projects, they'll appear here.</p>
//             <Link to="/new-project" className="btn-primary-custom">
//               <FaRocket /> Create New Project
//             </Link>
//           </div>
//         ) : (
//           <div className="projects-grid-modern">
//             <AnimatePresence>
//               {projects.map((project, index) => (
//                 <motion.div
//                   key={project.id}
//                   className="project-card-modern"
//                   initial={{ opacity: 0, y: 20 }}
//                   animate={{ opacity: 1, y: 0 }}
//                   exit={{ opacity: 0, y: -20 }}
//                   transition={{ duration: 0.4, delay: index * 0.1 }}
//                 >
//                   {/* Image Section */}
//                   <div className="card-image-section">
//                     {project.images?.length > 0 ? (
//                       <img
//                         src={project.images[0].image}
//                         alt={project.title}
//                         className="card-image"
//                       />
//                     ) : (
//                       <div className="no-image-placeholder">
//                         <FaImage className="placeholder-icon" />
//                         <span>No Image</span>
//                       </div>
//                     )}
//                     <div className="card-badges">
//                       <span className={`status-badge-overlay ${project.status?.toLowerCase().replace(' ', '-')}`}>
//                         {project.status?.replace('-', ' ') || 'Unknown'}
//                       </span>
//                       {project.unread_updates_count > 0 && (
//                         <span className="unread-badge pulse">
//                           {project.unread_updates_count} new
//                         </span>
//                       )}
//                     </div>
//                   </div>

//                   {/* Content Section */}
//                   <div className="card-content-section">
//                     <div className="project-header">
//                       <div className="project-title-section">
//                         <h3>{project.title}</h3>
//                       </div>
//                       <div className="project-budget">
//                         KSh {(project.agreed_cost || 0).toLocaleString()}
//                       </div>
//                     </div>

//                     <div className="project-meta-grid">
//                       <div className="meta-item">
//                         <FaClock className="meta-icon" />
//                         <div>
//                           <label>Last Update</label>
//                           <span>{formatTime(project.last_update_time)}</span>
//                         </div>
//                       </div>
//                       <div className="meta-item">
//                         <FaCalendar className="meta-icon" />
//                         <div>
//                           <label>Deadline</label>
//                           <span>{project.deadline ? new Date(project.deadline).toLocaleDateString() : 'Not set'}</span>
//                         </div>
//                       </div>
//                     </div>

//                     {/* Progress Bar Section */}
//                     <div className="progress-section-modern">
//                       <div className="progress-header">
//                         <span>Project Progress</span>
//                         <span className="progress-percent">{project.progress || 0}%</span>
//                       </div>
//                       <div className="progress-bar-container">
//                         <div
//                           className="progress-fill"
//                           style={{
//                             width: `${project.progress || 0}%`,
//                             backgroundColor: getProgressColor(project.progress || 0)
//                           }}
//                         />
//                       </div>
//                     </div>

//                     <div className="project-footer">
//                       <button 
//                         className="project-action primary"
//                         onClick={() => handleOpenMessages(project)}
//                         disabled={isMarkingRead}
//                       >
//                         <FaEnvelope />
//                         {project.unread_updates_count > 0 
//                           ? `View Messages (${project.unread_updates_count})` 
//                           : 'View Messages'}
//                       </button>
//                     </div>
//                   </div>
//                 </motion.div>
//               ))}
//             </AnimatePresence>
//           </div>
//         )}
//       </div>

//       {/* Image Viewer Modal */}
//       <Modal
//         show={!!selectedImage}
//         onHide={() => setSelectedImage(null)}
//         centered
//         size="xl"
//         className="image-viewer-modal"
//       >
//         <Modal.Body className="image-viewer-body">
//           {selectedImage && (
//             <>
//               <button className="viewer-close" onClick={() => setSelectedImage(null)}>
//                 <IoClose />
//               </button>
//               <img src={selectedImage} alt="Project update" className="viewer-image" />
//               <div className="image-info">
//                 <span>Project Update Image</span>
//                 <span>Click outside to close</span>
//               </div>
//             </>
//           )}
//         </Modal.Body>
//       </Modal>
//     </div>
//   );
// };

// // Make sure to export the component properly
// export default withAuth(ClientProjectUpdates, 'client');


// src/pages/client/Updates.jsx
import React, { useState, useEffect } from 'react';
import { Link, useNavigate } from 'react-router-dom';
import { Modal } from 'react-bootstrap';
import { motion, AnimatePresence } from 'framer-motion';
import { serverUrlAuth } from '../../../serverUrl';
import Sidebar from '../../../components/layout/Sidebar';
import './updates.scss';
import withAuth from '../../auth/WithAuth';
import { IoClose } from 'react-icons/io5';
import {
  FaEnvelope,
  FaRocket,
  FaProjectDiagram,
  FaClock,
  FaCalendar,
  FaImage,
} from 'react-icons/fa';

const ClientProjectUpdates = () => {
  const navigate = useNavigate();

  const [projects, setProjects] = useState([]);
  const [selectedImage, setSelectedImage] = useState(null);
  const [isMarkingRead, setIsMarkingRead] = useState(false);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    fetchProjects();
  }, []);

  const fetchProjects = async () => {
    setLoading(true);
    try {
      const res = await serverUrlAuth.get('/projects/client-project-updates/');
      setProjects(res.data);
    } catch (err) {
      console.error('Error fetching projects:', err);
    } finally {
      setLoading(false);
    }
  };

  const markMessagesAsRead = async (projectId) => {
    if (!projectId) return;

    setIsMarkingRead(true);
    try {
      await serverUrlAuth.post(`/updates/messages/${projectId}/mark-read/`);
      await fetchProjects();
    } catch (err) {
      console.error('Error marking messages as read:', err);
    } finally {
      setIsMarkingRead(false);
    }
  };

  const handleOpenMessages = async (project) => {
    await markMessagesAsRead(project.id);
    navigate('/messages');
  };

  const formatTime = (dateString) => {
    if (!dateString) return 'No messages yet';
    const date = new Date(dateString);
    const now = new Date();
    const diffMs = now - date;
    const diffMins = Math.floor(diffMs / 60000);
    const diffHours = Math.floor(diffMs / 3600000);
    const diffDays = Math.floor(diffMs / 86400000);

    if (diffMins < 1) return 'Just now';
    if (diffMins < 60) return `${diffMins}m ago`;
    if (diffHours < 24) return `${diffHours}h ago`;
    if (diffDays === 1) return 'Yesterday';
    if (diffDays < 7) return `${diffDays}d ago`;
    return date.toLocaleDateString();
  };

  const getProgressColor = (progress) => {
    if (progress < 30) return '#8b2e1a'; // brick (was red)
    if (progress < 70) return '#b8860b'; // goldenrod (was brand)
    return '#6b8e23'; // olive (was green)
  };

  const getTotalUnreadCount = () => {
    return projects.reduce(
      (total, project) => total + (project.unread_updates_count || 0),
      0,
    );
  };

  if (loading) {
    return (
      <>
        <Sidebar />
        <div className="modern-dashboard updates-page">
          <div className="dashboard-loader">
            <div className="orbit-spinner">
              <div></div>
              <div></div>
              <div></div>
            </div>
            <p>Crafting your experience…</p>
          </div>
        </div>
      </>
    );
  }

  return (
    <>
      <Sidebar />
      <div className="modern-dashboard updates-page">
        {/* Hero Section */}
        <section className="hero-craftsmanship">
          <div className="hero-pattern"></div>
          <div className="hero-content-modern">
            <div className="welcome-badge">
              <span className="badge-icon">📢</span>
              <span>Project Updates</span>
            </div>
            <h1 className="hero-title">
              <span className="gradient-text">Stay Informed</span>
              <span className="hero-accent">Track Your Progress</span>
            </h1>
            <p className="hero-subtitle">
              Stay informed about your project progress with real-time updates
              from artisans. Never miss an important milestone or message.
            </p>
            <div className="hero-stats-modern">
              <div className="stat-item">
                <FaProjectDiagram className="stat-icon" />
                <div>
                  <h3>{projects.length}</h3>
                  <p>Total Projects</p>
                </div>
              </div>
              <div className="stat-item">
                <FaEnvelope className="stat-icon" />
                <div>
                  <h3>{getTotalUnreadCount()}</h3>
                  <p>Unread Messages</p>
                </div>
              </div>
            </div>
          </div>
        </section>

        {/* Main Content */}
        <div className="projects-showcase">
          <div className="section-header-modern">
            <h2>
              <span className="header-icon">📋</span>
              Your Projects
              <span className="header-line"></span>
            </h2>
          </div>

          {projects.length === 0 ? (
            <div className="empty-state-modern">
              <div className="empty-icon">📭</div>
              <h3>No projects with updates yet</h3>
              <p>
                When artisans send you updates about your projects, they'll
                appear here.
              </p>
              <Link to="/new-project" className="btn-primary-custom">
                <FaRocket /> Create New Project
              </Link>
            </div>
          ) : (
            <div className="projects-grid-modern">
              <AnimatePresence>
                {projects.map((project, index) => (
                  <motion.div
                    key={project.id}
                    className="project-card-modern"
                    initial={{ opacity: 0, y: 20 }}
                    animate={{ opacity: 1, y: 0 }}
                    exit={{ opacity: 0, y: -20 }}
                    transition={{ duration: 0.4, delay: index * 0.1 }}
                  >
                    {/* Image Section */}
                    <div className="card-image-section">
                      {project.images?.length > 0 ? (
                        <img
                          src={project.images[0].image}
                          alt={project.title}
                          className="card-image"
                        />
                      ) : (
                        <div className="no-image-placeholder">
                          <FaImage className="placeholder-icon" />
                          <span>No Image</span>
                        </div>
                      )}
                      <div className="card-badges">
                        <span
                          className={`status-badge-overlay ${project.status
                            ?.toLowerCase()
                            .replace(' ', '-')}`}
                        >
                          {project.status?.replace('-', ' ') || 'Unknown'}
                        </span>
                        {project.unread_updates_count > 0 && (
                          <span className="unread-badge pulse">
                            {project.unread_updates_count} new
                          </span>
                        )}
                      </div>
                    </div>

                    {/* Content Section */}
                    <div className="card-content-section">
                      <div className="project-header">
                        <div className="project-title-section">
                          <h3>{project.title}</h3>
                        </div>
                        <div className="project-budget">
                          KSh {(project.agreed_cost || 0).toLocaleString()}
                        </div>
                      </div>

                      <div className="project-meta-grid">
                        <div className="meta-item">
                          <FaClock className="meta-icon" />
                          <div>
                            <label>Last Update</label>
                            <span>{formatTime(project.last_update_time)}</span>
                          </div>
                        </div>
                        <div className="meta-item">
                          <FaCalendar className="meta-icon" />
                          <div>
                            <label>Deadline</label>
                            <span>
                              {project.deadline
                                ? new Date(
                                    project.deadline,
                                  ).toLocaleDateString()
                                : 'Not set'}
                            </span>
                          </div>
                        </div>
                      </div>

                      {/* Progress Bar Section */}
                      <div className="progress-section-modern">
                        <div className="progress-header">
                          <span>Project Progress</span>
                          <span className="progress-percent">
                            {project.progress || 0}%
                          </span>
                        </div>
                        <div className="progress-bar-container">
                          <div
                            className="progress-fill"
                            style={{
                              width: `${project.progress || 0}%`,
                              backgroundColor: getProgressColor(
                                project.progress || 0,
                              ),
                            }}
                          />
                        </div>
                      </div>

                      <div className="project-footer">
                        <button
                          className="project-action primary"
                          onClick={() => handleOpenMessages(project)}
                          disabled={isMarkingRead}
                        >
                          <FaEnvelope />
                          {project.unread_updates_count > 0
                            ? `View Messages (${project.unread_updates_count})`
                            : 'View Messages'}
                        </button>
                      </div>
                    </div>
                  </motion.div>
                ))}
              </AnimatePresence>
            </div>
          )}
        </div>

        {/* Image Viewer Modal */}
        <Modal
          show={!!selectedImage}
          onHide={() => setSelectedImage(null)}
          centered
          size="xl"
          className="image-viewer-modal"
        >
          <Modal.Body className="image-viewer-body">
            {selectedImage && (
              <>
                <button
                  className="viewer-close"
                  onClick={() => setSelectedImage(null)}
                >
                  <IoClose />
                </button>
                <img
                  src={selectedImage}
                  alt="Project update"
                  className="viewer-image"
                />
                <div className="image-info">
                  <span>Project Update Image</span>
                  <span>Click outside to close</span>
                </div>
              </>
            )}
          </Modal.Body>
        </Modal>
      </div>
    </>
  );
};

export default withAuth(ClientProjectUpdates, 'client');